/**
 * How long we should wait for the frontend hCaptcha API call before timing out and proceeding with the login
 *  without an hCaptcha token.
 */ export var HCAPTCHA_FRONTEND_TIMEOUT_MS = 'HCAPTCHA_FRONTEND_TIMEOUT_MS';
